import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.css'
import {hasPermission,downloadPost,downloadGet} from "./utils/request";
import {handleTree } from "@/utils/tree";

// 自定义表格工具组件
import RightToolbar from "@/components/RightToolbar";
import Pagination from "@/components/Pagination";
import less from "less"
import {initMenu} from "./utils/menus";
import  jwt  from  'jsonwebtoken'
import  JSEncrypt  from  'jsencrypt'
import '@/styles/index.scss'
import '@/icons'
import Tinymce from '@/components/tinymce/index.vue'
import modal from '@/plugins/modal'
import cache from "@/plugins/cache";

import DictTag from '@/components/DictTag'

import { addDateRange,parseTime} from "@/utils/ws";

// 修改 el-dialog 默认点击遮照为不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false

Vue.config.devtools = true // 启用Vue调试工具
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(less)
Vue.prototype.jsEncrypt = JSEncrypt;
Vue.prototype.$jwt=jwt
Vue.prototype.$modal = modal
Vue.prototype.$cache = cache
Vue.prototype.hasPermission=hasPermission
Vue.prototype.$downloadGet = downloadGet
Vue.prototype.$downloadPost = downloadPost
Vue.prototype.handleTree = handleTree
Vue.prototype.addDateRange = addDateRange
Vue.prototype.parseTime = parseTime
Vue.component('RightToolbar', RightToolbar)
Vue.component('Pagination', Pagination)
Vue.component('tinymce', Tinymce)
Vue.component('DictTag', DictTag)

router.beforeEach((to, from, next)=>{
  initMenu(router,store)
  next();
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



